<template>
    <div>
        <div v-if="$root.hotelCode === 'novotelluxembourgcentre'">
            <div class="text-center -mt-4">
                <a href="https://bit.ly/2XLRyvO" target="_blank" class="text-blue-600 hover:text-blue-700">https://bit.ly/2XLRyvO</a>
                <div class="pt-1 pb-3 leading-tight text-tower-blue">
                    {{ $root.currentLanguage == 'fr' 
                        ? 'Cliquez sur le lien pour rejoindre ALL – ACCOR LIVE LIMITLESS YOUR LIFESTYLE LOYALTY PROGRAMME'
                        : 'Click the link to join ALL - ACCOR LIVE LIMITLESS YOUR LIFESTYLE LOYALTY PROGRAMME'  
                    }}
                </div>
            </div>
        </div>
        <div class="ad__social mb-1" v-if="($root.hotel.hotel_icons) && $root.hotel.hotel_icons.length > 0">
            <div class="ad__social-line">
                <div class="social__item flex text-center h-16 justify-center">
                    <a target="blank" :href="icon.external_link" style="padding:6px; width: 65px;" v-for="icon in $root.hotel.hotel_icons" :key="icon.id">
                        <img class="w-full h-full object-contain" :src="$root.getImage(icon.icon)" alt="">
                    </a>
                </div>
                <p class="text-center text-sm text-gray-700" v-if="$root.hotel.general_text_icons !== '' && ($root.getLangObject($root.hotel.general_text_icons).length > 0)" v-text="$root.getLangObject($root.hotel.general_text_icons)"></p>
            </div>
            <div v-if="$root.hotelCode === 'novoteltowerbridge'">
                <div class="text-center mt-4 text-tower-blue">We are Cashless, Card payments only.</div>
                <div class="text-center mt-2">
                    <div class="pt-1 pb-3 leading-tight text-tower-blue">
                        Click the banner to join ALL - ACCOR LIVE LIMITLESS YOUR LIFESTYLE LOYALTY PROGRAMME 
                    </div>
                </div>
            </div>
        </div>
    </div>
</template> 

<script>
export default {
  name: 'AppSocial',
}
</script>

<style>
    .text-tower-blue {
        color: #050033;
    }
</style>
